<template>
  <div>
    <a-spin class="spinning" :spinning="loading">
      <div class="container">
        <template v-if="bindDocList.length">
          <div class="list">
            <div
              class="doctap"
              v-for="(item, index) in bindDocList"
              :key="item.ucDoctorId"
              :class="{ right: (index + 1) % 3 === 0 }"
            >
              <div class="content">
                <div class="info">
                  <span class="name">{{ item.doctorName }}</span>
                  <span class="txt depart">{{ item.departmentName }}</span>
                  <span class="txt">{{ item.academicTitle }}</span>
                </div>
                <div class="hosp">{{ item.hospitalName }}</div>
              </div>
              <div class="explain z-flex">
                <span class="source">来源：{{ item.bindSourceDesc }}</span>
                <span class="date">{{ item.bindTime }}</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <a-pagination
              :pageSizeOptions="['9', '18', '27', '36']"
              show-size-changer
              v-model:current="pagination.current"
              v-model:pageSize="pagination.pageSize"
              :total="pagination.total"
              @change="onShowSizeChange"
              @showSizeChange="onShowSizeChange"
              :show-total="total => `总共 ${pagination.total} 条`"
            />
          </div>
        </template>
        <a-empty v-else />
      </div>
    </a-spin>
  </div>
</template>
<script setup>
import { defineProps, ref, reactive, computed, onMounted } from 'vue'
import { getBindDocList } from '@/api/chat'
import { useStore } from 'vuex'
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    type: String,
    default: ''
  }
})

const store = useStore()
const ucPatientId = computed(() => {
  return props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
})
const loading = ref(false)
const bindDocList = ref([])
const initPagination = {
  current: 1,
  pageSize: 9,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
const pagination = reactive({ ...initPagination })
const params = reactive({
  current: 1,
  size: 9,
  ucPatientId: ucPatientId.value
})
onMounted(() => {
  Object.assign(pagination, initPagination)
  getData()
})
// 查询数据
function getData() {
  loading.value = true
  const { current, pageSize } = pagination
  params.current = current
  params.size = pageSize
  try {
    getBindDocList({ ...params }).then(res => {
      const { list = [], currPage, totalCount } = res
      bindDocList.value = list
      loading.value = false
      pagination.current = currPage
      pagination.total = totalCount
    })
  } catch {
    loading.value = false
    bindDocList.value = []
  }
}
// 改变每页条数
const onShowSizeChange = (page, pageSize) => {
  pagination.current = page
  pagination.pageSize = pageSize
  getData()
}
</script>
<style scoped lang="scss">
%time {
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}

.container {
  padding: 0 8px;
  .search-wrap {
    margin-bottom: 20px;
  }
  .list {
    display: grid;
    grid-template-columns: repeat(3, 33.3%);
    .doctap {
      display: flex;
      flex-direction: column;
      background: #f8f8f8;
      border-radius: 8px;
      padding: 12px;
      margin-right: 12px;
      margin-bottom: 12px;
      &.right {
        margin-right: 0;
      }
      .content {
        flex: 1;
        .info {
          margin-bottom: 9px;
          .name {
            font-size: 14px;
            color: #1a1a1a;
            padding-right: 12px;
          }
          .txt {
            font-size: 12px;
            color: #999999;
          }
          .depart {
            padding-right: 6px;
            margin-right: 6px;
            border-right: 1px solid #999999;
          }
        }
        .hosp {
          margin-bottom: 19px;
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
      }

      .explain {
        .source {
          font-weight: 400;
          font-size: 12px;
          color: #3b3b3b;
        }
        .date {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
  .pagination {
    padding: 12px 0 20px;
  }
}
</style>
